import { Experience } from './components/Experience'
import { CoreSkills } from './components/CoreSkills'
import { CommunityAndAchievements } from './components/CommunityAndAchievements'
import { Education } from './components/Education'
import { ProfessionalDevelopment } from './components/ProfessionalDevelopment'
import { Resume } from './components/Resume'
import { Page } from './components/Page'
import Header from './components/Header'
import { parseBullet } from './utils'

import { ReactComponent as YTreeLogo } from './assets/logo.y-tree.svg'
import { ReactComponent as CiklumLogo } from './assets/logo.ciklum.svg'
import { ReactComponent as LohikaLogo } from './assets/logo.lohika.svg'
import { ReactComponent as CircleLogo } from './assets/logo.circle.svg'
import { ReactComponent as ApiariLogo } from './assets/logo.apiari.svg'
import { ReactComponent as ProductCraftersLogo } from './assets/logo.productcrafters.svg'

import { experience, summary, featureFlags } from './data'
import "./App.scss";

const logoMap = {
  YTreeLogo: <YTreeLogo />,
  CiklumLogo: <CiklumLogo />,
  LohikaLogo: <LohikaLogo />,
  CircleLogo: <CircleLogo />,
  ApiariLogo: <ApiariLogo />,
  ProductCraftersLogo: <ProductCraftersLogo />,
};

const displayExperienceData = experience.map((job) => ({
  ...job,
  ...job.dates[featureFlags.experienceDatesMode],
}));

function App() {
  return (
    <Resume>
      <Page>
        <Header />

        <main>
          <h2 className="work-experience-title">Work experience</h2>

          <div className="work-experience">
            {displayExperienceData.map((job) => (
              <Experience
                key={job.company}
                position={job.position}
                company={job.company}
                location={job.location}
                companyLink={job.companyLink}
                startDate={job.startDate}
                endDate={job.endDate}
                companyLogo={logoMap[job.companyLogo]}
                skills={job.skills}
                bullets={job.bullets}
              />
            ))}
          </div>

          {featureFlags.showExperienceOverlapDisclaimer && (
            <p className="work-experience-disclaimer">
              * Some roles overlap due to concurrent freelance/consulting engagements.
            </p>
          )}
        </main>
      </Page>

      <Page>
        <main>
          <Education />

          <ProfessionalDevelopment />

          <CommunityAndAchievements />
          
          {featureFlags.showCoreSkillsSection && <CoreSkills />}

          <h2>More about me</h2>
          <div className="more-about-me">
            <p className="bio">
              {parseBullet(summary)}
            </p>
            <div className="languages">
              <h3>Languages spoken</h3>
              <span>{Object.entries({ "English": "C1", "Ukrainian": "Native", "Russian": "Native" }).map(([language, level]) => featureFlags.showLanguageLevel ? `${language} (${level})` : language).join(', ')}</span>
            </div>
          </div>
        </main>
      </Page>
    </Resume>
  );
}

export default App;
